import { useGame, useS, getLocalRole } from '../../store/game';
import { ROLES, pl, isChan } from '../../engine/versus';

const nameOf = (S: any, r: 'host' | 'guest') => (isChan(r) ? S.name : pl(r).party?.n) || (r === 'host' ? 'Host' : 'Gast');

/** Mehrspieler: „Weiter“ erst, wenn alle Spieler bereit sind. Gibt Statuszeile und Knopf zurück. */
export function useReady() {
  const S = useS(); const { dispatch } = useGame(); const r = getLocalRole();
  const ready = S.mp?.ready || {};
  const me = !!ready[r], others = ROLES.filter((x) => x !== r), waiting = others.filter((x) => !ready[x]);
  const status = me
    ? (waiting.length ? `Ihr seid bereit. Warte auf ${waiting.map((x) => nameOf(S, x)).join(', ')} …` : 'Alle bereit.')
    : others.some((x) => ready[x]) ? `${others.filter((x) => ready[x]).map((x) => nameOf(S, x)).join(', ')} ist bereit und wartet auf euch.` : 'Die Zeit läuft weiter, sobald alle auf „Weiter“ geklickt haben.';
  const button = (blocked: string | null = null) => me
    ? <button type="button" className="ghost" onClick={() => dispatch('ready', false)}>Doch noch warten</button>
    : <button type="button" className="yes" disabled={!!blocked} onClick={() => dispatch('ready', true)}>Weiter ▸</button>;
  return { status, button, me, othersReady: others.some((x) => ready[x]) };
}
